module.exports = __webpack_public_path__ + "img/多肽服务.3c1d3616.png";